import styled from 'styled-components'

import { SelectFormField } from '@/components/UberForm'
import { colors } from '@/styles'

import { DragProps, DropProps } from './types'

const ACTION_COLUMN_WIDTH = '2.5rem'

export const TableWrap = styled.div<{
	$actionCellWidth?: string
	$isSubRowTable?: boolean
	$maxWidth?: number
	$scrollWithParent?: boolean
}>`
	/* This is required to make the table full-width */
	display: block;
	max-width: ${({ $maxWidth, $scrollWithParent }) =>
		$scrollWithParent ? 'none' : $maxWidth ? `${$maxWidth}px` : '100%'};
	min-width: ${({ $scrollWithParent }) => ($scrollWithParent ? '100%' : '0')};
	width: ${({ $scrollWithParent }) => ($scrollWithParent ? '100%' : 'auto')};
	overflow-x: ${({ $scrollWithParent }) => ($scrollWithParent ? 'visible' : 'auto')};
	overflow-y: ${({ $scrollWithParent }) => ($scrollWithParent ? 'visible' : 'hidden')};
	padding-bottom: ${({ $isSubRowTable }) => ($isSubRowTable ? '0' : '4.5rem')};

	th {
		position: ${({ $scrollWithParent }) =>
			$scrollWithParent ? 'sticky' : 'relative'};
		top: 0;
		z-index: ${({ $scrollWithParent }) => ($scrollWithParent ? 2 : 'auto')};
		padding: 0.313rem 0.5rem;
		background: ${(props) => props.theme.colors.primary.base};
		color: #fff;
	}

	table {
		/* Make sure the inner table is always as wide as needed */
		width: 100%;
		min-width: ${({ $scrollWithParent }) =>
			$scrollWithParent ? 'max-content' : '0'};
		border-spacing: 0;
		table-layout: fixed;

		td {
			padding: 0;
		}

		/* Fixes the issue with blank row below expandedRow */
		.expandedRow + tr {
			display: none !important;
		}

		.expandedRow {
			td {
				border-top: none;
				border-bottom: none;
				border-right: none;
			}
		}

		th,
		td {
			margin: 0;
			border: 1px solid ${colors.table.thead.borderColor};
			vertical-align: middle;
		}

		/* Fixes the issue with checkboxes => not centered */
		input {
			width: 100%;
		}

		input[type='text'] {
			border: none;
		}

		.table__closeBtn {
			position: sticky;
			top: 0;
			right: 0;
		}
	}

	.pagination {
		padding: 0.5rem;
	}

	.textInputWithoutBorder {
		border: none;
		min-height: 32px;
	}
`

export const TableHeaderContentWrap = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`

export const TableActionTh = styled.th`
	width: ${ACTION_COLUMN_WIDTH};
	min-width: ${ACTION_COLUMN_WIDTH};
	max-width: ${ACTION_COLUMN_WIDTH};
	padding: 0 !important;
	visibility: hidden;
	border: none !important;
	flex-shrink: 0;
`

export const TableActionCell = styled.td<{
	$alwaysShowRowActions?: boolean
	$hasLastRowEdit: boolean
	$isEditMode: boolean
	$isLastRow: boolean
}>`
	width: ${ACTION_COLUMN_WIDTH};
	min-width: ${ACTION_COLUMN_WIDTH};
	padding: 0 !important;
	cursor: pointer;
	text-align: center;
	vertical-align: middle;
	border: none !important;
	visibility: ${({
		$alwaysShowRowActions,
		$isEditMode,
		$isLastRow,
		$hasLastRowEdit,
	}) => {
		if (!$hasLastRowEdit && $isLastRow) {
			return 'hidden'
		}

		return $isEditMode || $alwaysShowRowActions ? 'visible' : 'hidden'
	}};
	flex-shrink: 0;
`

export const Row = styled.tr<DragProps & DropProps>`
	opacity: ${({ $isDragging }) => ($isDragging ? 0.3 : 1)};
	border-bottom: ${({ $isDragOver, $canDrop, $yDiff }) => {
		if ($canDrop && $isDragOver && $yDiff > 0) {
			return '0.125rem solid'
		}

		return 'none'
	}};
	border-top: ${({ $isDragOver, $canDrop, $yDiff }) => {
		if ($canDrop && $isDragOver && $yDiff < 0) {
			return '0.125rem solid'
		}

		return 'none'
	}};
`

export interface SelectProps {
	$error?: string
	$focused?: boolean
	rows?: number
	variant?: 'textarea'
}

export const TableSelect = styled(SelectFormField)<SelectProps>`
	height: 100%;
	width: 100%;
	margin-bottom: 1px;
	margin-right: 0;

	.react-select__control {
		border: none;
	}
`
